module.exports = __webpack_public_path__ + "img/img2.410a559b.png";